export default __webpack_public_path__ + "assets/cr_logo_white.6752409b3df4890622c7fe678846f5ec.svg";